module.exports = __webpack_public_path__ + "static/img/success_bj2.72f0c14.png";